import { EDIT_MODE_FIELDS, STAFF_SOURCE, contractNoOf, saveStaffFields } from '../../../services/contractStaff';

/**
 * Edit Mode's Save on the contracts store (REACT_APP_CONTRACTS_V2 on). Only the Invygo car typed by hand is staff data
 * (EDIT_MODE_FIELDS); every other cell of a row is Ejar's and is not saved here - `ignored` names any that came (the
 * page does not make them editable). Each contract is saved on its version as it is now (saveStaffFields), 10 at a
 * time as before; one contract refused never stops the others.
 * `changesOf(item)`: the cells the user touched AND changed ({pageKey: value}).
 * Returns {saved: [items], failed: [{item, error}], ignored: [page keys]}.
 */
export const saveEditsToStore = async (items, changesOf, { save = saveStaffFields, chunkSize = 10 } = {}) => {
    const out = { saved: [], failed: [], ignored: [] };
    for (let i = 0; i < (items || []).length; i += chunkSize) {
        const chunk = items.slice(i, i + chunkSize);
        const results = await Promise.allSettled(chunk.map(async (item) => {
            const changes = changesOf(item) || {};
            const staff = {};
            Object.entries(changes).forEach(([key, value]) => {
                if (key in EDIT_MODE_FIELDS) staff[EDIT_MODE_FIELDS[key]] = value;
                else if (!out.ignored.includes(key)) out.ignored.push(key);
            });
            if (!Object.keys(staff).length) return false;
            await save(contractNoOf(item), staff, STAFF_SOURCE.table);
            return true;
        }));
        results.forEach((r, k) => {
            if (r.status === 'rejected') out.failed.push({ item: chunk[k], error: r.reason });
            else if (r.value) out.saved.push(chunk[k]);
        });
    }
    return out;
};
